import { Controller } from "stimulus";
export default class extends Controller {

  static get targets() {
    return [
      'image',
    ];
  }

  initialize() {
    if (this.imageTargets.length < 2) {
      return;
    }
    this.images = this.imageTargets;
    this.fadeDuration = parseFloat(getComputedStyle(this.element).getPropertyValue('transition-duration'), 10) * 1000;
    this.duration = parseFloat(this.element.dataset.slideDuration, 10) * 1000;
    this.index = 0;

    this.interval = setInterval(() => {
      this.changeImage();
    }, this.duration + this.fadeDuration);
  }

  changeImage() {
    const length = this.images.length;
    const currentEl = this.images[this.index];
    let nextIndex;

    if (this.index === 0 && currentEl.classList.contains('opacity-0')) {
      this.images.forEach(element => {
        element.classList.remove('opacity-0');
        element.classList.remove('pointer-events-none');
      });
    }
    else {
      currentEl.classList.add('opacity-0');
      currentEl.classList.add('pointer-events-none');

      if (this.index + 2 < length) {
        nextIndex = this.index + 1;
      }
      else {
        nextIndex = 0;
      }

      this.index = nextIndex;
    }
  }
};